import type { ImportRow } from "./itemImport.api";

const INVALID_CODE_MESSAGE = "유효하지 않거나 판매 상태가 아닌 상품번호 입니다.";

export function importCodeBorderClass(row: Pick<ImportRow, "shop_item_gid" | "lookup_error">): string {
  if (row.lookup_error) return "is-invalid";
  if (row.shop_item_gid) return "item-import-code-valid";
  return "";
}

export function lookupErrorMessage(error?: unknown): string {
  const status = (error as { response?: { status?: number } } | undefined)?.response?.status;
  if (status === 429) return "상점 API 요청 한도에 도달했습니다. 잠시 후 다시 시도해 주세요.";
  if (!error || status === 400 || status === 404) return INVALID_CODE_MESSAGE;
  return "상품코드 확인 중 오류가 발생했습니다.";
}
